import { TalentCoBg } from './talentco-bg'
import { register as registerEmployment } from './domains/employment/register'
import {
  EmployerOrganisationSettingsGate,
  type TenantPluginRegister,
} from '@yeshuman/sdk'

export const register: TenantPluginRegister = (app) => {
  registerEmployment(app)
  app.routes.add({
    path: '/organisation/settings/*',
    element: EmployerOrganisationSettingsGate,
  })
  app.dashboard.section('candidate', 'sections')
  app.dashboard.section('employer')
  app.chrome.background(TalentCoBg)
  app.chrome.card({ hideDescription: true })
  app.publicShare.layout({ maxWidthPx: 1000 })
  app.register({
    emphasizeJobFacts: true,
    guestBackgroundClassName: 'opacity-75 dark:hidden',
    guestMarketingShellBackground: true,
    tenantLogoFallback: true,
  })
}

export const providesDomains = ['employment']

export const requiresProduct = '>=2.12,<3'
